export const fontFamily = {
  attrs: {
    fontFamily: {
      default: 'inherit'
    }
  },
  toDOM(mark) {
    return ['span', {
      style: "font-family: ".concat(mark.attrs.fontFamily, ";"),
      display: 'inline-block'
    }, 0];
  },
  parseDOM: [{
    tag: 'span',
    getAttrs: dom => {
      const fontFamily = dom.style['font-family'];
      if (fontFamily) {
        return {
          fontFamily
        };
      }
      return false;
    }
  }]
};